import { render, staticRenderFns } from "./DataTableNaf.vue?vue&type=template&id=01a8c823&scoped=true"
import script from "./DataTableNaf.vue?vue&type=script&lang=js"
export * from "./DataTableNaf.vue?vue&type=script&lang=js"
import style0 from "./DataTableNaf.vue?vue&type=style&index=0&id=01a8c823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8c823",
  null
  
)

export default component.exports